export default function initPopin(buttons) {
  if (buttons.length) import(/* webpackChunkName: "Popin" */"@mozaic-ds/freemarker/js/modules/_modal.js").then(module => {
    buttons.forEach(button => button.addEventListener('click', () => {
      const classContent = [...button.nextElementSibling.classList].filter(c => c.startsWith('js'))[0];
      new module.default({
        classContent
      }).open();
    }));
  }).catch(console.error);
}